import axios from 'axios';

export const API_URL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'; // FastAPIのエンドポイント

// Axiosのリクエストインターセプターを設定
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Axiosのレスポンスインターセプターを設定
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // 401エラー（認証エラー）の場合
    if (error.response && error.response.status === 401) {
      // ローカルストレージをクリア
      localStorage.removeItem('token');
      localStorage.removeItem('userId');

      // ログイン画面にリダイレクト
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
